import React, { FC, useRef } from 'react';
import Resizer from '../Resizer';
import { isTouch } from '../../../../components/utils/browser';
import { useEditorContainerSize } from '../../../../components/Editor/Context';
import { useWidth } from '../../hooks/useWidth';
import { PapiDeviation } from '@wix/da-papi-types';

import viewerStyles from '../../Viewer/Viewer.scss';

export interface Props {
  deviation: PapiDeviation;
  link?: string;
  Renderer: React.FC<any>;
  onResizeEnd?: (width: number, height: number) => void;
  extOptions?: any;
  attrWidth: number | null;
  defaultWidth: number;
  alignment: string;
  editorDomRef: any;
}

const DaDeviation: FC<Props> = ({
  deviation,
  link,
  Renderer,
  onResizeEnd,
  extOptions,
  attrWidth,
  defaultWidth,
  alignment,
  editorDomRef,
}) => {
  const containerSize = useEditorContainerSize();
  const figureRef = useRef<HTMLElement>(null);

  const { width, maxWidth } = useWidth(
    attrWidth,
    defaultWidth,
    extOptions.smallMedia,
    alignment,
    containerSize ?? 0
  );

  return (
    <figure
      className={viewerStyles['deviation-figure']}
      ref={figureRef}
      style={{ width }}
      data-dadeviation="true"
      data-deviation={JSON.stringify(deviation)}
    >
      <div
        style={{
          maxHeight: '100%',
          pointerEvents: 'none',
        }}
      >
        <Renderer
          deviation={deviation}
          width={width}
          extOptions={extOptions}
          link={link}
        />
      </div>
      {!isTouch() && extOptions.canResize && (
        <Resizer
          key={width}
          editorDom={editorDomRef.current}
          imageRef={figureRef}
          minWidth={10}
          maxWidth={maxWidth}
          minHeight={10}
          maxHeight={Infinity}
          keepRatio={true}
          onResizeEnd={onResizeEnd}
        />
      )}
    </figure>
  );
};
DaDeviation.displayName = 'DaDeviation';

export default DaDeviation;
